var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.664,
    viewBox: "0 0 19.5 19.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Users_default_16px",
    transform: "translate(-368.728 -193.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160588",
    "data-name": "Group 160588",
    transform: "translate(369.478 193.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3228",
    "data-name": "Group 3228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M14.929,19.627a7.234,7.234,0,0,0,6.139-.639V18.8c0-2.512-1.683-4.551-3.747-4.551a3.622,3.622,0,0,0-3.1,1.995",
    transform: "translate(-3.069 -3.402)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 3.065,
    cy: 3.065,
    r: 3.065,
    transform: "translate(2.8)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3227",
    "data-name": "Group 3227",
    transform: "translate(0 9.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M13.846,19.334v.114a10.151,10.151,0,0,1-11.6,0v-.114c0-3.632,2.6-6.584,5.8-6.584a5.734,5.734,0,0,1,5.084,3.416",
    transform: "translate(-2.25 -12.75)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M14.929,18.852h0a5.775,5.775,0,0,0-.719-2.792",
    transform: "translate(-3.332 -12.404)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M16.946,10.729A2.385,2.385,0,0,1,17.383,6h0A2.39,2.39,0,0,1,19.72,7.892",
    transform: "translate(-3.139 -2.89)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 0.518,
    cy: 0.518,
    r: 0.518,
    transform: "translate(15.553 6.911)",
    fill: "#787f88"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersWhiteIcon);
export default __webpack_public_path__ + "static/media/users-white-icon.5b4d22a007c851f7617e9e115af0a35e.svg";
export { ForwardRef as ReactComponent };